<div class="qc-toaster">
	<cv-notification
		*ngIf="notifications[NOTIFICATION_TYPE.ERROR].show"
		(hide)="clearNotification(NOTIFICATION_TYPE.ERROR)"
		[animationType]="'top'"
		[message]="notifications[NOTIFICATION_TYPE.ERROR].message"
		[type]="'danger'"
		[autoClose]="notifications[NOTIFICATION_TYPE.ERROR].autoClose"
		[displayTime]="5"
	>
	</cv-notification>
	<cv-notification
		*ngIf="notifications[NOTIFICATION_TYPE.SUCCESS].show"
		(hide)="clearNotification(NOTIFICATION_TYPE.SUCCESS)"
		[animationType]="'top'"
		[message]="notifications[NOTIFICATION_TYPE.SUCCESS].message"
		[type]="'success'"
		[autoClose]="notifications[NOTIFICATION_TYPE.SUCCESS].autoClose"
		[displayTime]="5"
	>
	</cv-notification>
	<cv-notification
		*ngIf="notifications[NOTIFICATION_TYPE.WARNING].show"
		(hide)="clearNotification(NOTIFICATION_TYPE.WARNING)"
		[animationType]="'top'"
		[message]="notifications[NOTIFICATION_TYPE.WARNING].message"
		[type]="'warning'"
		[autoClose]="notifications[NOTIFICATION_TYPE.WARNING].autoClose"
		[displayTime]="5"
	>
	</cv-notification>
	<cv-notification-update
			*ngIf="notifications[NOTIFICATION_TYPE.UPDATE_APP].show"
			[title]="'Update Available'"
			[message]="notifications[NOTIFICATION_TYPE.UPDATE_APP].message"
			(update)="onUpdateApplication($event)"
	>
	</cv-notification-update>
	<cv-notification
			*ngIf="notifications[NOTIFICATION_TYPE.NEW_RELEASE_LOG_APP].show"
			(hide)="clearNotification(NOTIFICATION_TYPE.NEW_RELEASE_LOG_APP)"
			[animationType]="'top'"
			[message]="notifications[NOTIFICATION_TYPE.NEW_RELEASE_LOG_APP].message"
			[type]="'info'"
			[autoClose]="false"
			(notificationAction)="onOpenReleaseNotes($event)"
	>
	</cv-notification>

	<cv-release-notes
			*ngIf="openReleaseNotes"
			(closeDialog)="openReleaseNotes = false;">
	</cv-release-notes>

	<cv-notification
		#prettyToaster
		*ngIf="notifications[NOTIFICATION_TYPE.TOASTER].show"
		[format]="FORMAT_TYPE.PRETTY"
		[options]="notifications[NOTIFICATION_TYPE.TOASTER].options"
		(hide)="clearNotification(NOTIFICATION_TYPE.TOASTER)">
	</cv-notification>
</div>
